/**
 * Detects url hash to set last opened category during a page reload due to
 * user login.
 */
export class GroupBtnAutoSelectComponent {
  constructor(parent) {
    this.parent = parent;
  }

  async loadState() {
    const uriHashParts = window.location.hash.split('/');

    if (uriHashParts.length > 1) {
      let [id, group] = uriHashParts;
      id = id.replace(/^#/, '');

      if (id == this.parent.id) {
        const $btnGroup = this.parent.$container.find(`.swatch-group-btn[data-name=${group}]`);
        $btnGroup.parent().find('.swatch-group-btn').not($btnGroup).removeClass('active');
        $btnGroup.addClass('active')
        const groupName = $btnGroup.attr('data-name');
        const $group = this.parent.$container.find(`.swatch-group[data-name=${groupName}]`);
        if ($group && $group.length > 0) {
          $group.addClass('active');
          $group.siblings().removeClass('active');
        }
      }
    }
  }
}